var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { transparentize, darken, tint } from 'polished';
import React, { useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import { SAUX360Theme } from '../theme';
// TODO: Pull button height from theme once the button heights have been added to the theme
function getHeight(variant) {
    var height;
    if (variant.includes('small')) {
        height = "30px";
    }
    else if (variant.includes('medium')) {
        height = "40px";
    }
    else if (variant.includes('large')) {
        height = "50px";
    }
    else {
        height = "50px";
    }
    return height;
}
function getFontSize(variant, theme) {
    var fontSize;
    if (variant.includes('small')) {
        fontSize = "" + theme.font.primary.size.smallTEMP;
    }
    else if (variant.includes('medium')) {
        fontSize = "" + theme.font.primary.size.medium;
    }
    else if (variant.includes('large')) {
        fontSize = "" + theme.font.primary.size.mediumTEMP;
    }
    else {
        fontSize = "" + theme.font.primary.size.mediumTEMP;
    }
    return fontSize;
}
function getPadding(variant, theme) {
    var padding;
    if (variant.includes('small')) {
        padding = theme.size.spacer.xs + " " + theme.size.spacer.medium;
    }
    else if (variant.includes('medium')) {
        padding = theme.size.spacer.small + " " + theme.size.spacer.medium;
    }
    else if (variant.includes('large')) {
        padding = theme.size.spacer.medium + " " + theme.size.spacer.large;
    }
    else {
        padding = theme.size.spacer.medium + " " + theme.size.spacer.large;
    }
    return padding;
}
// TODO: Add button color pairs to theme and tokens.
var StyledButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var textTransform = _a.textTransform, endIcon = _a.endIcon, fullWidth = _a.fullWidth, fullWidthUnder = _a.fullWidthUnder, startIcon = _a.startIcon, variant = _a.variant, colorOverride = _a.colorOverride, disabled = _a.disabled, theme = _a.theme;
    // TODO: Add button color pairs to theme and tokens. Current handling is not intuitive.
    // This will be cleaned up once the theme & tokens have been updated.
    var themeColorPair = colorOverride
        ? {
            background: theme.colors[colorOverride],
            foreground: '#fff',
        }
        : theme.color.primary; // Use for secondary buttons... I know...  :-)
    var height = getHeight(variant);
    if (variant.includes('primary')) {
        themeColorPair = theme.color.secondary;
    }
    if (variant.includes('link')) {
        if (colorOverride) {
            themeColorPair = {
                background: 'transparent',
                foreground: theme.colors[colorOverride],
            };
        }
        else
            themeColorPair = theme.color.link;
    }
    var backgroundColor = variant.includes('outline') ? 'transparent' : themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.background;
    var border = variant.includes('outline') ? "1px solid " + (themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.background) : 'transparent';
    var color = variant.includes('outline') ? themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.background : themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.foreground;
    if (variant.includes('lightweight')) {
        if (variant.includes('primary')) {
            backgroundColor = tint(0.9, theme.color.secondary.background);
            color = theme.colors.green900;
        }
        if (variant.includes('secondary')) {
            backgroundColor = tint(0.9, theme.color.primary.background);
            color = theme.colors.blue900;
        }
        if (colorOverride) {
            backgroundColor = tint(0.9, theme.colors[colorOverride]);
            color = theme.colors[colorOverride];
        }
    }
    if (variant.includes('link')) {
        backgroundColor = themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.background;
        border = 'transparent';
        color = themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.foreground;
        if (variant.includes('primary')) {
            color = theme.color.secondary.background;
        }
        if (variant.includes('secondary')) {
            color = theme.color.primary.background;
        }
    }
    if (variant.includes('outline') && variant.includes('inverse')) {
        border = "1px solid " + (themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.foreground);
        color = themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.foreground;
    }
    if (variant.includes('link') && variant.includes('inverse')) {
        color = 'white';
    }
    var backgroundColorHover = backgroundColor && darken(0.1, backgroundColor);
    if (backgroundColor === 'transparent' && color) {
        backgroundColorHover = transparentize(0.95, color);
    }
    if (disabled && !variant.includes('inverse')) {
        if (variant.includes('link')) {
            color = theme.color.disabled.background;
        }
        else if (variant.includes('outline')) {
            border = "1px solid " + theme.color.disabled.background;
            color = theme.color.disabled.background;
        }
        else {
            backgroundColor = theme.color.disabled.background;
            color = theme.color.disabled.foreground;
        }
        backgroundColorHover = backgroundColor;
    }
    var fontSize = getFontSize(variant, theme);
    var padding = getPadding(variant, theme);
    var width = fullWidth ? '100%' : 'initial';
    var responsiveAtSize = fullWidthUnder
        ? "@media only screen and (max-width: " + fullWidthUnder + "px) {\n          width: 100%;\n        }"
        : "";
    var endIconLeftMargin = endIcon
        ? "svg:last-child {\n          margin-left: " + theme.size.spacer.small + ";\n        }"
        : "";
    var startIconRightMargin = startIcon
        ? "svg:first-child {\n          margin-right: " + theme.size.spacer.small + ";\n        }"
        : "";
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      align-items: center;\n      background-color: ", ";\n      border: ", ";\n      border-radius: ", ";\n      box-sizing: border-box;\n      color: ", ";\n      display: flex;\n      font-family: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      justify-content: center;\n      margin: 0;\n      padding: ", ";\n      text-decoration: none;\n      text-transform: ", ";\n      width: ", ";\n      height: ", ";\n      cursor: pointer;\n\n      ", "\n\n      ", "\n\n      ", "\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      &:disabled {\n        cursor: not-allowed;\n      }\n    "], ["\n      align-items: center;\n      background-color: ", ";\n      border: ", ";\n      border-radius: ", ";\n      box-sizing: border-box;\n      color: ", ";\n      display: flex;\n      font-family: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      justify-content: center;\n      margin: 0;\n      padding: ", ";\n      text-decoration: none;\n      text-transform: ", ";\n      width: ", ";\n      height: ", ";\n      cursor: pointer;\n\n      ", "\n\n      ", "\n\n      ", "\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      &:disabled {\n        cursor: not-allowed;\n      }\n    "])), backgroundColor, border, theme.size.radius.small, color, theme.font.primary.family, fontSize, theme.font.primary.weight.bold, padding, textTransform, width, height, responsiveAtSize, startIconRightMargin, endIconLeftMargin, backgroundColorHover);
});
export function SAButton(_a) {
    var children = _a.children, endIcon = _a.endIcon, fullWidth = _a.fullWidth, fullWidthUnder = _a.fullWidthUnder, label = _a.label, onClick = _a.onClick, startIcon = _a.startIcon, variant = _a.variant, color = _a.color, disabled = _a.disabled, className = _a.className, customTheme = _a.theme, rest = __rest(_a, ["children", "endIcon", "fullWidth", "fullWidthUnder", "label", "onClick", "startIcon", "variant", "color", "disabled", "className", "theme"]);
    var theme = customTheme || useContext(ThemeContext) || SAUX360Theme;
    if (onClick && label && children) {
        return (React.createElement(StyledButton, __assign({ "aria-label": label, type: "button", endIcon: endIcon, fullWidth: fullWidth, fullWidthUnder: fullWidthUnder, onClick: function (e) { return onClick(e); }, startIcon: startIcon, variant: variant, colorOverride: color, disabled: disabled, className: "sa-button " + (className || ''), theme: theme }, rest),
            startIcon,
            children,
            endIcon));
    }
    if (onClick && label && !children) {
        return (React.createElement(StyledButton, __assign({ type: "button", endIcon: endIcon, fullWidth: fullWidth, fullWidthUnder: fullWidthUnder, onClick: function (e) { return onClick(e); }, startIcon: startIcon, variant: variant, colorOverride: color, disabled: disabled, className: "sa-button " + (className || '') }, rest),
            startIcon,
            label,
            endIcon));
    }
    if (!onClick && label && children) {
        return (React.createElement(StyledButton, __assign({ "aria-label": label, type: "button", endIcon: endIcon, fullWidth: fullWidth, fullWidthUnder: fullWidthUnder, startIcon: startIcon, variant: variant, colorOverride: color, disabled: disabled, className: "sa-button " + (className || ''), theme: theme }, rest),
            startIcon,
            children,
            endIcon));
    }
    if (!onClick && label && !children) {
        return (React.createElement(StyledButton, __assign({ type: "button", endIcon: endIcon, fullWidth: fullWidth, fullWidthUnder: fullWidthUnder, startIcon: startIcon, variant: variant, colorOverride: color, disabled: disabled, className: "sa-button " + (className || ''), theme: theme }, rest),
            startIcon,
            label,
            endIcon));
    }
    return React.createElement(React.Fragment, null);
}
SAButton.defaultProps = {
    children: undefined,
    endIcon: undefined,
    fullWidth: false,
    onClick: undefined,
    startIcon: undefined,
    textTransform: 'uppercase',
    variant: 'primary',
    color: undefined,
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=button.component.js.map